module.exports = __webpack_public_path__ + "static/img/info.660b95a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info.jpg
// module id = SYTV
// module chunks = 101